import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  DongleAgreementManagement_CreateDongleAssetRequestModel,
  DongleAgreementManagement_UpdateP1DongleAssetRequestModel,
  RequestModels_DongleAgreementManagement_DonglePairRequestModel,
  ResponseDataSystem_Guid,
  ResponseModels_DongleAgreementManagementV2_ConnectedDongleInfoV2ResponseModel,
  ResponseModels_DongleAgreementManagement_DongleAgreementResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetDongleAgreementV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId?: number;
};
/**
 * Get the P1 Dongle service agreement for a specific customer.
 *
 * @returns ResponseModels_DongleAgreementManagementV2_ConnectedDongleInfoV2ResponseModel Success
 */
export function getDongleAgreementV2(
  { businessUnit, label, customerId, accountId }: GetDongleAgreementV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_DongleAgreementManagementV2_ConnectedDongleInfoV2ResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/v2/dongle/agreement`,
      query: { accountId },
      errors: { 400: 'Bad Request', 500: 'Server Error' },
    },
    requestConfig,
  );
}

type PairDongleV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  requestBody: RequestModels_DongleAgreementManagement_DonglePairRequestModel;
  accountId?: number;
};
/**
 * Pairs a dongle to a P1 Dongle service agreement.
 *
 * @returns ResponseModels_DongleAgreementManagement_DongleAgreementResponseModel Success
 */
export function pairDongleV2(
  { businessUnit, label, customerId, requestBody, accountId }: PairDongleV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_DongleAgreementManagement_DongleAgreementResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/v2/dongle/pair`,
      query: { accountId },
      body: requestBody,
      errors: { 400: 'Bad Request', 500: 'Server Error' },
    },
    requestConfig,
  );
}

type UnpairDongleV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId?: number;
};
/**
 * Unpairs a dongle from a P1 Dongle service agreement.
 *
 * @returns ResponseModels_DongleAgreementManagement_DongleAgreementResponseModel Success
 */
export function unpairDongleV2(
  { businessUnit, label, customerId, accountId }: UnpairDongleV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_DongleAgreementManagement_DongleAgreementResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/v2/dongle/unpair`,
      query: { accountId },
      errors: { 400: 'Bad Request', 500: 'Server Error' },
    },
    requestConfig,
  );
}

type CreateP1DongleAsset = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId?: number;
  requestBody?: DongleAgreementManagement_CreateDongleAssetRequestModel;
};
/**
 * Create a new P1 Dongle Asset
 *
 * @returns ResponseDataSystem_Guid Success
 */
export function createP1DongleAsset(
  { businessUnit, label, customerId, accountId, requestBody }: CreateP1DongleAsset,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataSystem_Guid> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/v2/dongle/asset`,
      query: { accountId },
      body: requestBody,
      errors: { 400: 'Bad Request', 500: 'Server Error' },
    },
    requestConfig,
  );
}

type UpdateP1DongleAsset = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  assetId: string;
  accountId?: number;
  requestBody?: DongleAgreementManagement_UpdateP1DongleAssetRequestModel;
};
/**
 * Update an existing P1 Dongle Asset
 *
 * @returns any Success
 */
export function updateP1DongleAsset(
  { businessUnit, label, customerId, assetId, accountId, requestBody }: UpdateP1DongleAsset,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PATCH',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/v2/dongle/asset/${assetId}`,
      query: { accountId },
      body: requestBody,
      errors: { 400: 'Bad Request', 500: 'Server Error' },
    },
    requestConfig,
  );
}
